const ContactPhone = (props: any) => {
    const textAlign = props.textAlign ? props.textAlign : "center";
    const displayProp = props.display ? props.display : "inline";
    return (
        <>
            <span className="inter-thin" style={{"textAlign": textAlign, "margin": "0", "display": displayProp}}>+359 886 010 515</span>
        </>
    )
}

export default ContactPhone;